import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, ArrowRight } from 'lucide-react';
import { BrandWordmark } from '../components/brand/BrandWordmark';
import { PublicLayout } from '../components/layout/PublicLayout';
import {
  DocumentsPossessionsSection,
  FamilyConnectionsSection,
  LegacyMemorialSection,
  PrivacyTrustSection,
  StepInsideArchiveSection,
  StoryPromptsSection,
  VoiceMemorySection,
  WhyItMattersSection,
} from '../components/landing/productDemo/ProductDemoSections';
import '../styles/product-demo.css';

const shell = 'mx-auto w-full max-w-[75rem] px-4 sm:px-6 lg:px-8';

export default function HowItWorksPage() {
  return (
    <PublicLayout className="product-demo-page">
      <header className="border-b border-[hsl(38_14%_86%)] bg-[hsl(42_28%_99%)]/95">
        <div className={`${shell} flex items-center justify-between gap-4 py-4`}>
          <div className="flex min-w-0 items-center gap-3">
            <Link
              to="/"
              className="inline-flex shrink-0 items-center gap-1.5 text-sm text-muted-foreground hover:text-foreground"
            >
              <ArrowLeft className="h-4 w-4" />
              <span className="hidden sm:inline">Home</span>
            </Link>
            <BrandWordmark variant="navLanding" className="hidden sm:inline" />
          </div>
          <Link
            to="/register"
            className="inline-flex min-h-9 items-center justify-center rounded-full bg-[hsl(152_28%_22%)] px-4 text-sm font-semibold text-[hsl(42_30%_96%)] hover:bg-[hsl(152_28%_18%)]"
          >
            Start your archive
          </Link>
        </div>
      </header>

      <div className="product-demo-hero">
        <div className={shell}>
          <p className="product-demo-eyebrow">Product walkthrough</p>
          <h1 className="product-demo-heading mt-2 max-w-3xl text-3xl sm:text-4xl">
            How MyLegacyBridge works
          </h1>
          <p className="product-demo-copy mt-4 max-w-2xl text-base sm:text-lg">
            See how stories, voices, documents, memorials and Legacy Books come together in one private family archive.
          </p>
          <div className="mt-8 flex flex-wrap gap-3">
            <Link
              to="/register"
              className="inline-flex min-h-11 items-center justify-center gap-2 rounded-full bg-[hsl(152_28%_22%)] px-6 text-sm font-semibold text-[hsl(42_30%_96%)] hover:bg-[hsl(152_28%_18%)]"
            >
              Start your archive
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/pricing"
              className="inline-flex min-h-11 items-center justify-center gap-2 rounded-full border border-[hsl(38_16%_78%)] bg-white px-6 text-sm font-medium text-[hsl(24_14%_16%)] hover:border-[hsl(38_36%_42%)]"
            >
              View pricing
            </Link>
          </div>
        </div>
      </div>

      <main className="flex-1">
        <div className={shell}>
          <WhyItMattersSection />
        </div>

        <StepInsideArchiveSection />

        <div className={shell}>
          <StoryPromptsSection />
          <VoiceMemorySection />
          <DocumentsPossessionsSection />
          <FamilyConnectionsSection />
          <LegacyMemorialSection className="product-demo-section--pre-band" />
        </div>

        <PrivacyTrustSection />

        <section className="product-demo-final-cta" aria-labelledby="demo-final-cta-heading">
          <div className={shell}>
            <h2 id="demo-final-cta-heading" className="product-demo-heading">
              Start building your archive
            </h2>
            <p className="product-demo-copy mt-3 max-w-lg">
              Begin with one person, one memory, or one photo.
            </p>
            <div className="product-demo-final-cta__actions mt-8 flex flex-wrap items-center justify-center gap-3">
              <Link
                to="/register"
                className="inline-flex min-h-11 items-center justify-center gap-2 rounded-full bg-[hsl(152_28%_22%)] px-6 text-sm font-semibold text-[hsl(42_30%_96%)] hover:bg-[hsl(152_28%_18%)]"
              >
                Start your archive
                <ArrowRight className="h-4 w-4" />
              </Link>
              <Link
                to="/pricing"
                className="inline-flex min-h-11 items-center justify-center gap-2 rounded-full border border-[hsl(38_16%_78%)] bg-white px-6 text-sm font-medium text-[hsl(24_14%_16%)] hover:border-[hsl(38_36%_42%)]"
              >
                View pricing
              </Link>
            </div>
          </div>
        </section>
      </main>
    </PublicLayout>
  );
}
